import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import { Text } from '@atlaskit/primitives/compiled/text';
import { Box } from '@atlaskit/primitives/compiled/box';
import { token } from '@atlaskit/tokens';
import StatusSuccessIcon from '@atlaskit/icon/core/status-success';
import { cssMap } from '@atlaskit/css';

import { ProgressStatus } from './progress-types.ts';

const styles = cssMap({
	icon: {
		marginRight: token('space.100'),
	},
});

export const i18n: {
	uploadModalProgressTitleSuccess: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	uploadModalProgressTitleSuccess: {
		id: 'import-from-sources.upload-modal.progressTitleSuccess',
		defaultMessage: 'Import complete!',
		description: 'Status message when importing is succeeded',
	},
});

type ProgressMessageProps = {
	status: ProgressStatus;
	message: {
		id: string;
		defaultMessage?: string;
		description?: string;
	};
};

export const ProgressMessage: React.FC<ProgressMessageProps> = ({ status, message }) => {
	return status === ProgressStatus.SUCCESS ? (
		<Text>
			<Box as="span" xcss={styles.icon}>
				<StatusSuccessIcon color={token('color.icon.success')} label="Success" />
			</Box>
			<FormattedMessage {...i18n.uploadModalProgressTitleSuccess} />
		</Text>
	) : (
		<FormattedMessage {...message} />
	);
};
